import React, { useRef } from "react";
import { Table } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";

const MonthlyPaySheetExport = ({ reportData }) => {
  const tableRef = useRef(null);

  return (
    <>
      <DownloadTableExcel
        filename="Monthly Pay Sheet"
        sheet="MonthlyPaySheet"
        currentTableRef={tableRef.current}
      >
        <button className="btn btn-primary mx-2"> Export </button>
      </DownloadTableExcel>

      <Table ref={tableRef} style={{ display: "none" }}>
        <thead>
          <tr id="tbl" style={{ position: "relative" }}>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th
              className="text-center text-primary"
              style={{
                position: "absolute",
                width: "550px",
                right: "45%",
                bottom: "-18%",
                borderBottom: "2px solid purple",
              }}
            >
              ALLOWANCES
            </th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th
              className="text-center text-primary"
              style={{
                position: "absolute",
                width: "550px",
                right: "5%",
                bottom: "-18%",
                borderBottom: "2px solid purple",
              }}
            >
              DEDUCTIONS
            </th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
          </tr>
          <tr
            id="tbl"
            style={{
              position: "sticky",
              top: "0",
              zIndex: "2",
              backgroundColor: "gainsboro",
            }}
          >
            <th
              className="text-center"
              style={{
                position: "sticky",
                left: "0",
                zIndex: "2",
                backgroundColor: "gainsboro",
              }}
            >
              Sr.No
            </th>
            <th
              className="text-center"
              style={{
                position: "sticky",
                left: "0",
                zIndex: "2",
                backgroundColor: "gainsboro",
              }}
            >
              Voucher
            </th>
            <th
              className="text-center"
              style={{
                position: "sticky",
                left: "55px",
                zIndex: "2",
                backgroundColor: "gainsboro",
              }}
            >
              Code
            </th>
            <th
              className="text-center"
              style={{
                position: "sticky",
                left: "110px",
                zIndex: "2",
                backgroundColor: "gainsboro",
              }}
            >
              Name
            </th>
            <th className="text-center">Salary Days</th>
            <th className="text-center">Pay Scale</th>
            <th className="text-center">Basic Pay</th>
            <th className="text-center">Increment Total</th>
            <th className="text-center">BS Allowance</th>
            <th className="text-center">Additional Allowance</th>
            <th className="text-center">Extra Period Allowance</th>
            <th className="text-center">ADP Allowance</th>
            <th className="text-center">2nd Shift Allowance</th>
            <th className="text-center">DPT Allowance</th>
            <th className="text-center">College Allowance</th>
            <th className="text-center">Hostel Allowance</th>
            <th className="text-center">Invigilator Duty Allowance</th>
            <th className="text-center">Navttc Allowance</th>
            <th className="text-center">Conv Allow</th>
            <th className="text-center">Intermediate Allowance</th>
            <th className="text-center">GPF Return</th>
            <th
              className="text-center"
              style={{
                borderLeft: "1px solid black",
                borderRight: "1px solid black",
              }}
            >
              Gross Salary
            </th>
            <th className="text-center">GP Fund</th>
            <th className="text-center">Eobi</th>
            <th className="text-center">Eobi Payment</th>
            <th className="text-center">Loan Refund</th>
            <th className="text-center">Insu Dedu</th>
            <th className="text-center">Income Tax</th>
            <th className="text-center">Staff Van Dedu</th>
            <th className="text-center">Child Fee Dedu</th>
            <th className="text-center">Welfare Fund</th>
            <th className="text-center">Other Dedu</th>
            <th className="text-center">Net Salary</th>
          </tr>
        </thead>

        <tbody>
          {reportData.length > 0 &&
            reportData.map((subitem, index) => (
              <tr key={index} id="tbl">
                <td
                  style={{
                    color: "black",
                    position: "sticky",
                    left: "0",
                    zIndex: "1",
                    backgroundColor: "white",
                  }}
                  className="text_align_center"
                >
                  {index + 1}
                </td>
                <td
                  style={{
                    color: "black",
                    position: "sticky",
                    left: "0",
                    zIndex: "1",
                    backgroundColor: "white",
                  }}
                  className="text_align_center"
                >
                  {subitem.voucher?.voucher_no}
                </td>
                <td
                  style={{
                    color: "black",
                    position: "sticky",
                    left: "55px",
                    zIndex: "1",
                    backgroundColor: "white",
                  }}
                  className="text_align_center"
                >
                  {subitem.employee.emp_code}
                </td>
                <td
                  style={{
                    color: "black",
                    position: "sticky",
                    left: "110px",
                    zIndex: "1",
                    backgroundColor: "white",
                  }}
                  className="text_align_center"
                >
                  {subitem.employee.full_name}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.days}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.employee.pay_scale.payscale}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.basic_pay}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.increment}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.bs_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.additional_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.extra_period}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.adp_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.second_shift}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.dpt_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.college}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.hostel}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.invigilator_duty_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.navttc_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.convance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.intermediate_allowance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.gpf_return}
                </td>
                <td
                  style={{
                    color: "black",
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    backgroundColor: "beige",
                  }}
                  className="text_align_center"
                >
                  {Number(subitem.gross_salary)}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.gp_fund}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.eobi}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.eobi_payments}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.loan_refund}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.insurance}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.income_tax}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.van_charge}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.child_fee_deduction}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.welfare_fund}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {subitem.other_deduction}
                </td>
                <td style={{ color: "black" }} className="text_align_center">
                  {Number(subitem.net_pay)}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );
};

export default MonthlyPaySheetExport;
